// Only editorial opt-in card pickers: Enter uses the same native click/change
// path as mouse and Space. Variant fetching, prices and tracking stay in Heritage.
const homepage = document.querySelector('.coerviano-design .coerviano-home, .coerviano-design main:has(.coerviano-damen), .coerviano-design main:has(.coerviano-collection-products)');
if (homepage && !homepage.dataset.coervianoSwatchKeysBound) {
  homepage.dataset.coervianoSwatchKeysBound = 'true';
  homepage.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !(event.target instanceof HTMLInputElement)) return;
    const radio = event.target;
    if (radio.type !== 'radio' || !radio.closest('product-swatches[data-coerviano-color-fallback="true"]')) return;
    event.preventDefault();
    radio.click();
  });
}
